function o(t, n) {
  const e = [];
  for (let l = 0; l < t.length; l += n)
    e.push(t.slice(l, l + n));
  return e;
}
function h(t, n) {
  const e = Math.ceil(t.length / n);
  return Array.from(
    { length: n },
    (l, s) => t.slice(s * e, (s + 1) * e)
  );
}
export {
  h as splitIntoChunks,
  o as splitIntoSizedChunks
};
